import type { ReactNode } from 'react';

/**
 * Blue informational callout used at the top of library upload dialogs to
 * call out file-format limits and authoring hints. Both `CustomFormUploadDialog`
 * and `WordTemplateUploadDialog` use it; the content differs per dialog.
 */
export function LibraryUploadInfoCallout(props: { title?: string; children: ReactNode }) {
  return (
    <div className="rounded-lg border border-sky-200 dark:border-sky-500/30 bg-sky-50 dark:bg-sky-500/10 px-4 py-3 text-sm text-sky-900 dark:text-sky-200">
      {props.title && <h3 className="mt-0 mb-2 text-sm font-semibold">{props.title}</h3>}
      <div className="flex flex-col gap-2">{props.children}</div>
    </div>
  );
}
